import React from "react";
import {
  Button,
  Label,
} from "reactstrap";
import SelectInput, { components } from 'react-select';
import Services from "./Services";
import Utility from "../../Torzsadatok/Idopontfoglalo/Utility";
import { DatePicker } from "../../../commons/controls";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import RFForm from "../../../components/Form/RFForm";
import RFField from "../../../components/Form/RFField";

export default class IdopontPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      blockButtons: [],
      captchaToken: null,
      customDolgozo: false,
      date: null,
      dolgozoOptions: [],
      dolgozoSelected: null,
      helyszinJSON: [],
      helyszinObj: null,
      helyszinOptions: [],
      idoSelected: null,
      loading: false,
      napSelected: null,
      naptarBlockBeans: [],
      naptarJSON: {},
      naptarOptions: null,
      obj: {},
      orszagOptions: [],
      szolgaltatasJSON: [],
      szolgaltatasLeiras: null,
      szolgaltatasOptions: null,
      szolgaltatasSelected: null,
      szuletesnap: null,
      time: null,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDD']
      tableStatus: "HIDD"
    };

    this.captchaRef = React.createRef();

  }

  componentDidMount() {
    this.updateHelyszinFilter();
    this.getTelefonEnum();
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  updateHelyszinFilter = () => {
    Services.listHelyszin((err, res) => {
      if (!err) {
        let helyszinOptions = [];
        for (let helyszin of res[0]) {
          let option = <option value={helyszin.id}>{helyszin.nev}</option>;
          Utility.insertByOrder(helyszinOptions, option);
        }
        this.setState({ helyszinOptions, helyszinJSON: res[0] });
        if (helyszinOptions.length === 1)
          this.handleHelyszinChange(this, helyszinOptions[0].props.value);
      }
    });
  };

  updateSzolgaltatasFilter = helyszinid => {
    Services.listSzolgaltatasByHelyszin(helyszinid, (err, res) => {
      if (!err) {
        let szolgaltatasOptions = [];
        for (let szolgaltatas of res[0]) {
          let option = (
            <option value={szolgaltatas.id}>{szolgaltatas.nev}</option>
          );
          Utility.insertByOrder(szolgaltatasOptions, option);
        }
        this.setState({ szolgaltatasOptions, szolgaltatasJSON: res[0] });
      }
    });
  };

  renderNaptarBlocks = () => {
    const { naptarBlockBeans } = this.state;
    let blockButtons = [];
    let i = 1;
    for (const block of naptarBlockBeans) {
      let date = new Date(block.kezdet);
      let button = (
        <div
          className="col-2 col-xl-1"
          style={{ paddingLeft: 3, paddingRight: 3 }}
        >
          <Button
            value={block.kezdet}
            onClick={() => { this.setState({ idoSelected: block.kezdet }); }}
            active={this.state.idoSelected == block.kezdet}
            className="col-12"
            style={{ textAlign: 'center', paddingLeft: 0, paddingRight: 0 }}
          >
            {date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}
          </Button>
        </div>
      );
      blockButtons.push(button);
      if (i % 5 == 0)
        blockButtons.push(<div className="w-100 d-none d-md-block d-lg-none" />);
      if (i % 8 == 0)
        blockButtons.push(<div className="w-100 d-none d-xl-block" />);
      i++
    }
    return blockButtons;
  }

  getDolgozoOptions = (dolgozobeans) => {
    let dolgozoOptions = [];
    for (const dolgozo of dolgozobeans) {
      let option = <option value={dolgozo.id}>{dolgozo.nev}</option>;
      Utility.insertByOrder(dolgozoOptions, option);
    }
    this.setState({ dolgozoOptions });
  }

  getTelefonEnum = () => {
    Services.listTelefonEnum((err, res) => {
      if (!err) {
        this.setState({
          orszagOptions: res[0][0]
        });
      }
    });
  }

  setOrszaghivo = (value) => {
    this.state.orszagOptions.forEach((item) => {
      if (item.num === value) {
        this.setState({ orszaghivo: item.name.toUpperCase() });
      }
    });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({ [name]: value });
  }

  handleDolgozoChange = (event, value) => {
    const { helyszinObj, idoSelected, napSelected, szolgaltatasSelected } = this.state;
    value = this.emptyOrNull(value);
    let date = new Date(napSelected);
    date.setHours(0);
    date.setMinutes(0);
    Services.initFoglalas(date, helyszinObj.id, szolgaltatasSelected, value, false, true, (err, res) => {
      if (!err) {
        this.setState({ naptarBlockBeans: res[0].naptarblockbeans });
        if (!res[0].naptarblockbeans.some(element => element.kezdet == idoSelected))
          this.setState({ idoSelected: null });
      }
    });
    this.setState({ dolgozoSelected: value });
  }

  handleTimeChange = (event, value) => {
    const { customDolgozo, dolgozoSelected, helyszinObj, szolgaltatasSelected } = this.state;
    if (customDolgozo) {
      Services.initFoglalas(value || this.state.date, helyszinObj.id, szolgaltatasSelected, dolgozoSelected, true, false, (err, res) => {
        if (!err) {
          this.getDolgozoOptions(res[0].dolgozobeans);
          if (!res[0].dolgozobeans.some(element => element.id == dolgozoSelected)) {
            this.setState({ dolgozoSelected: null });
          }
        }
      });
      this.setState({ time: value });
    }
  }

  handleHelyszinChange = (event, value) => {
    const helyszinObj = this.state.helyszinJSON.find(obj => obj.id == value);
    this.setState({ helyszinObj, szolgaltatasSelected: '', idoSelected: null });
    this.updateSzolgaltatasFilter(value);
  };

  handleSzolgaltatasChange = (event, value) => {
    const szolgaltatas = this.state.szolgaltatasJSON.find(
      element => element.id == value
    );
    Services.customDolgozo(value, (err, res) => {
      if (!err) {
        this.setState({ customDolgozo: res[0] });
      }
    });
    this.setState({
      szolgaltatasSelected: value,
      szolgaltatasLeiras: szolgaltatas ? szolgaltatas.leiras : "",
      napSelected: '',
      blockButtons: []
    }, () => {
      this.updateNaptar();
    });
  };

  updateNaptar = () => {
    const { helyszinObj, szolgaltatasSelected } = this.state;
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long'
    };
    Services.listNaptarDays(helyszinObj.id, szolgaltatasSelected, (err, res) => {
      if (!err) {
        let naptarOptions = [];
        for (const instant of res[0]) {
          let date = new Date(instant);
          naptarOptions.push(
            <option value={instant}>
              {Intl.DateTimeFormat('hu', options).format(date)}
            </option>
          );
        }
        this.setState({ naptarOptions });
      }
    });
  }

  handleNapChange = (e, value) => {
    if (!value)
      return;
    const { customDolgozo, helyszinObj, szolgaltatasSelected } = this.state;
    let date = new Date(value);
    date.setHours(0);
    Services.initFoglalas(date, helyszinObj.id, szolgaltatasSelected, null, customDolgozo, true, (err, res) => {
      if (!err) {
        this.setState({ naptarBlockBeans: res[0].naptarblockbeans, napSelected: value, idoSelected: null, dolgozoSelected: '' });
        if (customDolgozo)
          this.getDolgozoOptions(res[0].dolgozobeans);
      }
    }
    );
  }

  handleVerificationSuccess = (token) => {
    this.setState({ captchaToken: token });
  }

  addFoglalas = (e, objModal) => {
    if (!objModal.hozzajarulas) {
      this.props.globals.addError('Időpont foglalásához az adatvédelmi nyilatkozat elfogadása kötelező!');
      return;
    }

    const {
      captchaToken,
      helyszinObj,
      idoSelected,
      orszaghivo,
      szolgaltatasSelected,
      szuletesnap,
    } = this.state;
    let insertObj = {
      kezdet: new Date(idoSelected),
      szolgaltatasid: szolgaltatasSelected,
      helyszinid: helyszinObj.id,
      captchatoken: captchaToken,
      partner: {
        vezeteknev: objModal.vezeteknev,
        keresztnev: objModal.keresztnev,
        szuletesnap: this.emptyOrNull(szuletesnap),
        email: objModal.email,
        telefon: objModal.tel,
        telefontipus: 'MOBIL',
        orszaghivo: orszaghivo && orszaghivo.name,
      },
      dolgozo: {
        id: objModal.dolgozoid
      }
    };
    Services.addFoglalas(insertObj, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás beküldve!');
        this.setState({ dolgozoSelected: '', idoSelected: null });
      } else {
        this.captchaRef.current.resetCaptcha();
      }
    });
  };

  renderValasztok = () => {
    const {
      helyszinObj,
      helyszinOptions,
      szolgaltatasLeiras,
      szolgaltatasOptions,
      szolgaltatasSelected,
    } = this.state;
    return (
      <div>
        <RFForm>
          <h2>Szolgáltatás</h2>
          <div className="col-md-6 col-xl-5">
            <RFField
              type="select"
              name="helyszinselect"
              label="Helyszín: *"
              value={helyszinObj && helyszinObj.id}
              onChange={this.handleHelyszinChange}
              defaultSelect={<option value="" disabled>Válassz helyszínt...</option>}
              selectOptions={helyszinOptions}
            />
          </div>
          <div className="col-md-6 col-xl-5">
            <RFField
              type="select"
              name="szolgaltatasselect"
              label="Szolgáltatás: *"
              value={szolgaltatasSelected}
              onChange={this.handleSzolgaltatasChange}
              disabled={!helyszinObj}
              defaultSelect={<option value="" disabled>Válassz szolgáltatást...</option>}
              selectOptions={szolgaltatasOptions}
            />
          </div>
          {szolgaltatasSelected &&
            <div className="col-md-6 col-xl-5">
            <Label>Szolgáltatás leírás:</Label>
              <textarea
                rows="2"
                name="leiras"
                value={szolgaltatasLeiras}
                style={{ minHeight: 50 }}
                readonly
              />
            </div>
          }
        </RFForm>
      </div>
    );
  };

  renderIdopont = () => {
    const {
      customDolgozo,
      dolgozoOptions,
      dolgozoSelected,
      napSelected,
      naptarBlockBeans,
      naptarOptions,
      szolgaltatasSelected,
    } = this.state;
    if (!szolgaltatasSelected)
      return;

    return <div>
      <h2>Időpont</h2>
      <RFForm>
        <div className="col-6 col-sm-5 col-md-4 col-xl-3">
          <RFField
            type="select"
            name="napselect"
            label='Foglalható időpontok: *'
            value={napSelected}
            onChange={this.handleNapChange}
            disabled={!naptarOptions}
            defaultSelect={<option value="" disabled>Válassz dátumot...</option>}
            selectOptions={naptarOptions}
          />
        </div>
        {napSelected &&
          <div>
            <div className="col-12 col-md-6 row no-gutters">
              {this.renderNaptarBlocks()}
            </div>
            <div className="col-md-6 col-xl-5">
              {customDolgozo && naptarBlockBeans.length != 0 &&
                <RFField
                  label="Dolgozó:"
                  name="dolgozoid"
                  type="select"
                  onChange={this.handleDolgozoChange}
                  value={dolgozoSelected}
                  defaultValue={Utility.returnFirstValueIfSingleElementArray(dolgozoOptions)}
                  defaultSelect={<option value=''>Válassz dolgozót...</option>}
                  selectOptions={dolgozoOptions}
                />
              }
            </div>
          </div>
        }
      </RFForm>
    </div>
  }

  renderSzemelyes = () => {
    const {
      helyszinObj,
      idoSelected,
      napSelected,
      orszagOptions,
    } = this.state;
    if (!idoSelected || !napSelected)
      return;

    const Option = ({ children, ...props }) => {
      const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
      const newProps = Object.assign(props, { innerProps: rest });
      return (
        <components.Option
          {...newProps}
        >
          <div className="flag-format" onClick={() => this.setOrszaghivo(props.data.num)}>
            <span
              className={'flag-icon flag-icon-' + props.data.name.toLowerCase()}
            />
            <b>{props.data.caption}</b>
            {' '}
            +
            {props.data.num}
          </div>
        </components.Option>
      );
    };

    return <div>
      <h2>Személyes adatok</h2>
      <RFForm onSubmit={this.addFoglalas}>
        <div className="row">
          <div className="col-sm-6">
            <div className="col-md-12">
              <RFField
                label="Vezetéknév: *"
                name="vezeteknev"
                required
              />
            </div>
            <div className="col-md-12">
              <RFField
                label="Keresztnév: *"
                name="keresztnev"
                required
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="col-md-12">
              <RFField
                label="E-mail cím: *"
                name="email"
                required
              />
            </div>
            <div className="col-md-12">
              <DatePicker
                label="Születési dátum:"
                id='szuletesnap'
                name='szuletesnap'
                onChange={v => this.handleSelectInputChange(v, 'szuletesnap')}
                max={new Date()}
              />
            </div>

          </div>
          <div className="col-sm-6">
            <div className="col-md-12">
              <Label>Országhívó:</Label>
              <SelectInput
                name="orszaghivo"
                id="orszaghivo"
                onChange={v => this.handleSelectInputChange(v, "orszaghivo")}
                components={{ Option }}
                isSearchable={true}
                className="mb-1"
                placeholder="Keresés..."
                getOptionLabel={option => option.caption}
                getOptionValue={option => option.num}
                options={orszagOptions}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="col-md-12">
              <RFField
                label="Telefonszám:"
                name="tel"
              />
            </div>
          </div>
          <div className="col-md-6 row">
            <div className="col-md-12">
              {helyszinObj && helyszinObj.hirlevelUrl &&
                <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                  <a href={helyszinObj.hirlevelUrl} target='_blank'>Feliratkozás hirlevélre</a>
                </div>}
                <div>
                  <RFField
                    label={
                      <div style={{ paddingLeft: '20px' }}>
                        *Elolvastam és elfogadom az adatvédelmi nyilatkozatot.
                        <a target='_blank' href={helyszinObj && helyszinObj.adatvedelmiUrl}> Bővebben </a>
                      </div>
                  }
                    type="checkbox"
                    name="hozzajarulas"
                  />
                </div>
              <HCaptcha
                sitekey="15c55834-40b0-46f3-9893-1a2b4b32553d"
                onVerify={(token) => this.handleVerificationSuccess(token)}
                ref={this.captchaRef}
              />
            </div>
            <div className="col-md-12">
              <Button>
                Foglalás elküldése
              </Button>
            </div>
          </div>
        </div>
      </RFForm>
    </div>
  }

  render() {
    return <div className="container-fluid">
      {this.renderValasztok()}
      {this.renderIdopont()}
      {this.renderSzemelyes()}
    </div>;
  }
}
